import { Dna, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Compact reusable Brand-DNA summary card. Shows niche + audience at a glance.
 * Renders nothing if no summary is available.
 */
export default function BrandDnaCard({ summary, variant = "compact" }) {
  const navigate = useNavigate();
  if (!summary) return null;

  if (variant === "hint") {
    // Tiny inline hint above an input field
    return (
      <div className="flex items-start gap-2 p-2.5 rounded-lg bg-cyan-500/5 border border-cyan-500/20" data-testid="brand-dna-hint">
        <Dna className="w-3.5 h-3.5 text-cyan-300 flex-shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1 text-[11px] leading-relaxed">
          <span className="text-cyan-200 font-semibold">Aus deiner Brand DNA: </span>
          <span className="text-zinc-300">{summary.niche}</span>
        </div>
      </div>
    );
  }

  // Default: compact card for dashboards
  return (
    <button
      onClick={() => navigate("/brand-dna")}
      className="group w-full text-left p-4 rounded-2xl bg-gradient-to-br from-cyan-500/10 to-cyan-400/5 border border-cyan-500/25 hover:border-cyan-400/50 transition-all"
      data-testid="brand-dna-card"
    >
      <div className="flex items-center gap-3 mb-3">
        <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-cyan-500/20 to-cyan-400/15 border border-cyan-500/30 flex items-center justify-center flex-shrink-0">
          <Dna className="w-4 h-4 text-cyan-300" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-xs uppercase tracking-wider text-cyan-300 font-semibold">Deine Brand DNA</p>
          <p className="text-[10px] text-zinc-500">Tippe für vollen Chat</p>
        </div>
        <ArrowRight className="w-4 h-4 text-zinc-500 group-hover:text-cyan-300 group-hover:translate-x-0.5 transition-all" />
      </div>
      <div className="space-y-2">
        <div>
          <p className="text-[10px] uppercase text-zinc-500 tracking-wider mb-0.5">Nische</p>
          <p className="text-sm text-zinc-100 leading-snug line-clamp-2">{summary.niche || "—"}</p>
        </div>
        <div>
          <p className="text-[10px] uppercase text-zinc-500 tracking-wider mb-0.5">Zielgruppe</p>
          <p className="text-xs text-zinc-300 leading-snug line-clamp-2">{summary.audience || "—"}</p>
        </div>
        {summary.core_promise && (
          <div>
            <p className="text-[10px] uppercase text-zinc-500 tracking-wider mb-0.5">Versprechen</p>
            <p className="text-xs text-zinc-300 leading-snug line-clamp-2">{summary.core_promise}</p>
          </div>
        )}
      </div>
    </button>
  );
}
